import { render, staticRenderFns } from "./PrizeForm.vue?vue&type=template&id=34662bd7&scoped=true"
import script from "./PrizeForm.vue?vue&type=script&lang=js"
export * from "./PrizeForm.vue?vue&type=script&lang=js"
import style0 from "./PrizeForm.vue?vue&type=style&index=0&id=34662bd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34662bd7",
  null
  
)

export default component.exports